import React from 'react';
import { Spinner } from 'reactstrap';
import SimpleBar from "simplebar-react"
import { allAttributes } from "../../../../common/data/requiredAttributes";

const OlxTab = () => {
    const part = JSON.parse(sessionStorage.getItem("partDetails"));
    const generateTitle = () => {
        let title = part.name;
        if(part.catalogNumber != "BB"){
            if((title.length + part.catalogNumber.length) < 64) {
                title += " " + part.catalogNumber;
                let catalogNumberModified = part.catalogNumber.replaceAll(" ", "");
                if((title.length + catalogNumberModified.length) < 65) title += " " +  catalogNumberModified;
            }
        }
        return title;
    };
    const generateSellingPrice = () => {
        return part.sellingPrice > 100 ? "Po dogovoru" : part.sellingPrice + " KM";
    }
    const generateDescription = () => {
        return part.description == null ? "Za ovaj artikal nije unesen opis." : part.description;
    };
    if (!part || !part.attributes || Object.keys(part).length === 0) {
        return (
          <div className="page-content text-center">
            <Spinner color="primary" />
            <p>Detalji o dijelu se učitavaju, molimo pričekajte...</p>
          </div>
        );
      }
    return (
        <div>
            <h5 className="mt-2 fw-bold">{"Naziv: " + generateTitle()}</h5>
            <h5 className="mt-2 fw-bold">{"Cijena: " + generateSellingPrice()}</h5>
            <div className="w-25 mt-2">
                <h5 className="fw-bold">Obavezna polja:</h5>
                <SimpleBar className="me-lg-n3 pe-lg-4" style={{ maxHeight: "200px" }}>
                    <ul className="list-unstyled mb-0">{part.attributes.map(item =>
                        <li>
                            <div className="fw-semibold fs-14 text-start text-uppercase">{allAttributes.find(attr => attr.olxId == item.olxId).name + ": " + item.option}</div>
                        </li>)}
                    </ul>
                </SimpleBar>
            </div>
            <h6 className="mt-3 fw-bold">Opis:</h6>
            <p>{generateDescription()}</p>
        </div>
    );
};

export default OlxTab;